"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _components = require("../../../components");

var _hooks = require("../../../hooks");

var _ModifierItemModule = _interopRequireDefault(require("./ModifierItem.module.scss"));

var _ThemeContext = require("../../../configProvider/ThemeContext");

var _visuallyHidden = require("@react-aria/visually-hidden");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var RadioWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border-radius: 100%;\n    box-shadow: 0 0 0 0.25rem ", ";\n"])), function (props) {
  return props.color || "transparent";
});

var ModiifierItem = (0, _styledComponents["default"])(function (_ref) {
  var cellType = _ref.cellType,
      name = _ref.name,
      price = _ref.price,
      quantity = _ref.quantity,
      multiSelect = _ref.multiSelect,
      onClick = _ref.onClick,
      className = _ref.className,
      increment = _ref.increment,
      decrement = _ref.decrement;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      primary = _useTemplate$useCell.buttons.primary,
      labelTextStyles = _useTemplate$useCell.labelTextStyles,
      views = _useTemplate$useCell.views;

  var _useContext = (0, _react.useContext)(_ThemeContext.ThemeContext),
      buttons = _useContext.themeData.parsedTheme.buttons;

  var buttonBorderColor = quantity ? buttons[primary].button.selected["border-color"] : buttons[primary].button.unselected["border-color"];
  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.background,
    className: "".concat(_ModifierItemModule["default"].modifierItem, " ").concat(className),
    onClick: !multiSelect || !quantity ? onClick : null,
    onKeyDown: !multiSelect || !quantity ? onClick : null,
    dataTest: name,
    Component: "li",
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.primary,
    className: _ModifierItemModule["default"]["modifierItem-name"]
  }, name), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: price
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary,
    className: _ModifierItemModule["default"]["modifierItem-price"]
  }, price)), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: multiSelect
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_ModifierItemModule["default"].selectors, quantity && _ModifierItemModule["default"]["modifierItem-qty"])
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: quantity !== 0
  }, /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: primary,
    className: (0, _classnames["default"])(_ModifierItemModule["default"]["modifierItem-qty--minus"]),
    onClick: decrement
  }), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    className: (0, _classnames["default"])(_ModifierItemModule["default"]["modifierItem-qty--text"]),
    type: labelTextStyles.tertiary,
    "aria-live": "polite"
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden.VisuallyHidden, null, name, " Quantity: "), quantity)), /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: primary,
    className: (0, _classnames["default"])(_ModifierItemModule["default"]["modifierItem-qty--plus"]),
    onClick: quantity !== 0 ? increment : null
  }))), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: !multiSelect
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition.False, null, /*#__PURE__*/_react["default"].createElement(RadioWrapper, {
    role: "button",
    tabIndex: "-1",
    onClick: onClick,
    onKeyDown: onClick,
    color: buttonBorderColor,
    className: _ModifierItemModule["default"]["modifierItem-radio-wrapper"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Radio, {
    type: primary,
    className: _ModifierItemModule["default"]["modifierItem-radio"],
    value: quantity
  })))));
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-bottom-color: ", "\n"])), function (props) {
  return props.theme.colors.alternateGray;
});

var _default = /*#__PURE__*/_react["default"].memo(ModiifierItem);

exports["default"] = _default;